import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors } from '@/utils/constants';

const lightTheme = {
  container: {
    '& $title': {
      color: TextColors.dark,
    },
    '& $jumplink': {
      color: SecondaryColors.dark,
      '&:hover, &:focus': {
        color: SecondaryColors.main,
        '& span': {
          textDecoration: `underline 1px ${SecondaryColors.main}`,
        },
      },

      '& span': {
        textDecoration: `underline 1px ${SecondaryColors.dark}`,
      },
    },
  },
};

const darkTheme = {
  container: {
    '& $title': {
      color: TextColors.light,
    },
    '& $jumplink': {
      color: SecondaryColors.main,
      '&:hover, &:focus': {
        color: SecondaryColors.light,
        '& span': {
          textDecoration: `underline 1px ${SecondaryColors.light}`,
        },
      },

      '& span': {
        textDecoration: `underline 1px ${SecondaryColors.main}`,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    container: {
      '&.dark-theme': darkTheme.container,
      '&.light-theme': lightTheme.container,

      [muiTheme.breakpoints.up('md')]: {
        textAlign: 'left',
      },
    },

    title: {
      '&.MuiTypography-root': {
        opacity: 0.8,
        marginBottom: '20px',
        textTransform: 'uppercase',
      },
    },

    jumplink: {
      display: 'block',
      cursor: 'pointer',
      whiteSpace: 'normal',
      width: 'fit-content',

      [muiTheme.breakpoints.up('md')]: {
        '&.MuiTypography-root': {
          fontSize: '18px',
          whiteSpace: 'nowrap',
        },
      },

      '& > *': {
        transition: 'all 150ms ease-in-out',
      },

      '&.wrapSpace': {
        [muiTheme.breakpoints.up('md')]: {
          whiteSpace: 'normal',
        },
      },

      '&:hover, &:focus': {
        '& span': {
          textDecoration: 'none',
        },
      },

      '& svg': {
        position: 'relative',
        top: '-1px',
      },
    },

    icon: {
      verticalAlign: 'middle',
      fontSize: '1.25em',
    },
  }),
  { name: 'GenJumplinks' },
);

export default useStyles;
